'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogActions", {
    enumerable: true,
    get: function() {
        return DialogActions;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDialogActions = require("./useDialogActions");
const _renderDialogActions = require("./renderDialogActions");
const _useDialogActionsStylesstyles = require("./useDialogActionsStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DialogActions = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDialogActions.useDialogActions_unstable)(props, ref);
    (0, _useDialogActionsStylesstyles.useDialogActionsStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDialogActionsStyles_unstable')(state);
    return (0, _renderDialogActions.renderDialogActions_unstable)(state);
});
DialogActions.displayName = 'DialogActions';
